import { render } from "./WCSearchInput.vue?vue&type=template&id=b37b0ff8&scoped=true"
import script from "./WCSearchInput.vue?vue&type=script&lang=js"
export * from "./WCSearchInput.vue?vue&type=script&lang=js"

import "./WCSearchInput.vue?vue&type=style&index=0&id=b37b0ff8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37b0ff8"]])

export default __exports__